/**
 * SignIn コンポーネント
 */
const sign_in = {
    title: 'サインイン',
    text01: 'ご登録いただいたメールドレス、パスワードでサービスサイトにサインインします。'
}

/**
 * TechnologicalDevelopment コンポーネント
 */
const technological_development = {
    title: '技術開発の傾向を把握'
}
const select = {
    title: '調査テーマの選択',
    text01: 'あなたの知りたいテーマを探し、選択してください。',
    tips01: 'テーマを入力中に、AIが近いテーマをサジェストして提案いたします。',
    tips02: 'テーマを選択すると、選択テーマに関連したテーマが案内されるため、類似テーマの探索時に便利です。',
    tips03: '右上の「テーマ一覧」から全ての登録されているテーマをカテゴリ毎に確認できます。'
}
const grasp = {
    title: 'テーマ概要から技術開発の傾向を把握',
    text01:
        '・テーマにおける技術開発の傾向を特許出願件数から把握し、あなたが取り組む価値のあるテーマか確認していきます。',
    howToUse01:
        '直近2年は（出願公開がまだのため）データが不足している可能性があります。直近2年を除いたデータの傾向を確認していきましょう。',
    howToUse02: '特許出願件数の推移、発明者数の推移のグラフは、技術の発展動向として横ばいか上昇傾向かが確認できます。',
    howToUse03:
        '地域別の特許出願件数の推移、出願先国（組織）別の特許出願件数の推移は、活発に技術が使われている国や技術はどこで、自社の進出エリアとマッチしているかが確認できます。',
    howToUse04:
        '技術の内訳を確認し、テーマに取り組む場合にはどのような技術が対象となるのか大まかに把握することができます。'
}

/**
 * ValueProvided コンポーネント
 */
const value_provided = {
    title: '提供価値の仮説構築'
}
const specific = {
    title: 'クラスタ＆バリューチェーン分析で注目したい技術開発を特定する',
    text01:
        'クラスタ＆バリューチェーンから技術動向を深掘りします。まずは、目的に応じた注目の技術群（クラスタ）を特定していきます。',
    howToUse01:
        'クラスタ・バリューチェーンは４つの領域に区切られており、目的に応じて確認するエリアが異なります。目的に応じて確認したい領域にある技術群を選択しましょう。',
    howToUse02:
        '新規事業の場合は、今後技術開発が進み技術トレンドとなる可能性の高い技術群が特定できるとよいため、領域2に属しているクラスタを確認するのがおすすめです。',
    howToUse03:
        'バブルを選択すると、画面下部のクラスタ一覧から、選択済みのクラスタに含まれる技術内容を確認できます。どのような技術があるのか領域ごとに探索することができます。',
    howToUse04:
        'クラスタ一覧から、注目したいクラスタを特定する場合は、例えば以下のような視点から確認すると示唆が得られます。',
    howToUse05: '＜スコア＞',
    howToUse06:
        '技術の進展度（スコア）が高いクラスタを特定したい場合は、「クラスタ一覧」の「スコア」をクリックし、データを降順にソートすると最も技術が進展しているクラスタがわかります。',
    howToUse07: '＜スコア成長率＞',
    howToUse08:
        '技術の成長率が高いクラスタを特定したい場合は、「クラスタ一覧」の「スコア成長率」をクリックし、データを降順にソートすると近年最も急速に技術が成長しているクラスタがわかります。',
    howToUse09: '＜市場期待値＞',
    howToUse10:
        '市場からの注目度が高いクラスタを特定したい場合は、「クラスタ一覧」の「市場期待値」をクリックし、データを降順にソートすると最も市場からの注目度が高いクラスタがわかります。',
    howToUse11: '＜市場期待値成長率＞',
    howToUse12:
        '市場からの注目度の成長率が高いクラスタを特定したい場合は、「クラスタ一覧」の「市場期待値成長率」をクリックし、データを降順にソートすると近年最も急速に市場からの注目度が上昇しているクラスタがわかります。',
    tips01: 'バブルが小さい（大きい）場合、「＋」ボタンで拡大（「-」ボタンで縮小）することができます。',
    tips02: '「設定」より表示データの変更や、x軸、y軸の設定、ズームスライダーの非表示など設定することができます。',
    tips03:
        'バブルチャートのx軸y軸の近くにあるスライダーを動かすことで表示する軸の領域を絞り込みができ、見たいエリアを拡大して確認することができます。',
    tips04: '「ラベル固定」を押すとクラスタ情報のラベルを固定表示できます。'
}

/**
 * SpecificIssues コンポーネント
 */
const specific_issues = {
    title: '具体的な課題と解決策の検討'
}
const analysis = {
    title: '自社の技術状況の分析',
    text01:
        '着目した技術群が自社の保有する技術や提供するサービスと親和性があり、取り組みたい技術であるかを確認していきます。',
    howToUse01: '企業間分析画面で自社の企業名を入力します。',
    howToUse02: 'テーマ内で自社（選択企業）の技術が含まれている技術群（クラスタ）の一覧が表示されます。',
    howToUse03:
        'スコアが表示されていれば、自社で技術を保有している状態なので、該当クラスタに対して技術を持っていることを確認します。',
    howToUse04: '濃いカラーほど値が高いため、競合他社との差を客観的に確認することができます。'
}

/**
 * AssumedTasks コンポーネント
 */
const assumed_tasks = {
    title: '想定課題を抱える顧客の探索'
}
const analyze_technology = {
    title: '川上川下の企業の視点で技術群を分析し、顧客と課題を推定する',
    text01:
        'より分析を深めるため、川上、川下、競合企業が保持している技術群を確認し、想定されている顧客と設定課題への理解を深めていきます。競合としてマークしたい企業を特定していきます。',
    howToUse01: '調べたい企業が決まっている場合',
    howToUse02:
        '「クラスタの特許出願一覧」から「特許出願保有企業」が競合先であるものを絞って確認することで、技術に紐づいている企業の特許一覧が取得できます。（表の右上のダウンロードアイコンを押下するとCSVファイルとしてダウンロードすることができます。データの絞り込みに便利です）',
    howToUse03:
        '特許の公開番号から他サービス等（Google Patent, Espacenet, J-PlatPatなど）で公開されている特許情報の詳細を確認し、周辺の対象顧客や課題の推察を行いましょう。',
    howToUse04: '調べたい企業が決まっていない場合',
    howToUse05: 'クラスタに含まれている企業を探索した上で、対象顧客や課題の推察を行うことができます。',
    howToUse06: '注目したい企業を探すいくつかの方法として２点紹介します。',
    howToUse07: '技術競争力が高い企業：「クラスタ詳細（企業）」からスコアが一番高い企業を特定することができます。',
    howToUse08:
        'クラスタ内でより中心的な技術を持つ企業：「クラスタの特許出願一覧」の因子負荷量が一番高い順でソートした上で、「特許出願保有企業」を確認すると、特定できます。'
}
const create_list = {
    title: 'スタートアップの財務・投資面からみたアライアンス先や投資先のロングリストを作成する',
    text01: 'スタートアップの財務・投資面からみたアライアンス先や投資先のロングリストを作成していきます。',
    howToUse01: 'スタートアップ企業リストを一括でリスト化したい場合',
    howToUse02:
        'バブルチャートからクラスタを選択した状態または、クラスタ一覧でクラスタを選択した状態で「クラスタ詳細（企業）」へ遷移します。',
    howToUse03: '右上のダウンロードアイコンをクリックし、CSVファイルをダウンロードします。',
    howToUse04:
        'CSVファイルをExcel等のソフトで開き、「スタートアップ=1（※）」で絞り込むとスタートアップの候補先のロングリストが作成できます。',
    howToUse05: '気になるスタートアップ企業をピックアップしてリスト化する場合',
    howToUse06:
        'バブルチャートからクラスタを選択した状態または、クラスタ一覧でクラスタを選択した状態で「クラスタ詳細（企業）」へ遷移します。',
    howToUse07:
        '気になるスタートアップ企業を探索します。\n例）スタートアップかつマイノリティ出資額が大きい（小さい）企業、スコア（技術競争力）が高い企業などを特定',
    howToUse08:
        '企業名をクリックし、企業情報を確認し、財務状況や投資元の企業の情報を踏まえて候補になる場合は、「お気に入りに登録」クリックし目星をつけた企業を記録することができます。',
    howToUse09: '「クラスタ詳細（企業）」の右上のダウンロードアイコンをクリックし、CSVファイルをダウンロードします。',
    howToUse10:
        'CSVファイルをExcel等のソフトで開き、「スタートアップ=1（※）」、お気に入りに登録した企業名のみでフィルターをかけると、ロングリストが作成できます。',
    howToUse11: '※「1」がスタートアップ、「0」がスタートアップではないことを意味しています。',
    tips01:
        '画面上でスタートアップ企業を確認したい場合は、表の「スタートアップ」をクリックすると、単項目で昇順、降順のソートができます。降順に並び替えるとスタートアップ企業を一番最初に表示できます。',
    tips02: 'Shiftボタンを押してから表の各項目名をクリックすると複数項目でソートができます。'
}

/**
 * Hypothesis コンポーネント
 */
const hypothesis = {
    title: '仮説の提供価値と解決策を検証'
}
const grasp_technology = {
    title: '競合との企業間分析により独自性や自社優位性のある技術分野を把握する',
    text01:
        '提供価値の仮説構築〜具体的な課題と解決策の検討の手順を経て、ある程度自社のポジションや競合他社の名前が出揃った段階で実施します。企業間分析では改めて自社優位性のあるクラスタ（技術群）かどうかを確認します。',
    text02: 'また、より有望なクラスタがある場合は目星をつけたクラスタを変更しながら分析を深めることができます。',
    howToUse01: '企業間分析画面にて、自社、アライアンス企業、競合企業を選択します。（最大5社まで比較可能）',
    howToUse02:
        'スコア（技術競争力）の高さが濃淡で表示されるため、自社が優位性を持ってとり組めるクラスタかどうかを改めて確認します。',
    howToUse03:
        '画面下部に「技術ポートフォリオ」が表示され、全体の技術動向における各社の技術保有状況がバブルチャート方式で俯瞰的に確認できます。',
    howToUse04:
        '競合企業に強みがある場合も、しっかりと競争力を発揮できる分野なのか、または競合企業と被らない分野になっているか、アライアンス先と提携することでどう弱点が補完できるかを把握することができます。',
    howToUse05:
        '比較した結果、競合他社の方が優れており、独自性や自社優位性の発揮が困難であると判断した場合、提供価値の仮説構築〜具体的な課題と解決策の検討に戻り、繰り返し分析をしていきます。',
    howToUse06:
        'また、他にも自社の優位性が発揮できるより有望なクラスタが存在する場合は、分析対象のクラスタを変更して繰り返し分析を行なっていきます。'
}
const create_report = {
    title: '事業創出・事業化に向けた報告用のレポートの作成',
    text01:
        '注目クラスタ及び顧客と顧客が持つ課題、提供価値、ロングリスト等が用意でき、事業創出、事業化に向けて報告用のレポート作成が必要になります。Intelligent Business Analyticsでは、レポート作成時に便利な機能をご用意しています。',
    howToUse01: 'レポートに盛り込むと良い観点として分析過程で確認した各種グラフ、特許データが活用できます。',
    howToUse02: '選定テーマのテーマ概要【図表】（技術開発の傾向として報告）',
    howToUse03: 'クラスタ＆バリューチェーンのバブルチャート【図表】（注目クラスタIDを表示）',
    howToUse04:
        '競合他社、川上、川下企業の保有特許出願一覧【 CSVファイル】（注目クラスタの特許情報及び想定顧客と想定課題、提供価値の裏付けとなる）',
    howToUse05: '企業間比較（自社、競合、アライアンス候補）【図表】（自社優位性の裏付けとなる）',
    howToUse06: 'ロングリスト【CSVファイル】'
}

/**
 * Tips コンポーネント
 */
const tips = {
    title01: '共通',
    title02: 'クラスタ＆バリューチェーンのバブルチャート',
    text01: {
        before: '',
        after: 'アイコンから「グラフをコピー」できます。(参考 スライド1-1,1-2)'
    },
    text02: {
        before: '',
        after: '黒い三角アイコンをドラッグするとグラフの横幅サイズを調整することができます。(参考 スライド1-1,1-2)'
    },
    text03:
        '「設定」から「ズームスライダー」をONにすると、x軸、y軸を絞り込めるスライダーを表示することができます。報告したい領域のみに絞ってチャートを見せられるため、必要に応じて活用してください。',
    text04:
        '「設定」から「ラベル固定」をONにした後に、「グラフをコピー」するとラベルごと図表がコピーできるため、報告時に便利です。',
    text05: '※ラベル固定をオンにするとクラスタの選択ができなくなるため、分析時はオフに戻してください。'
}

/**
 * Analysis コンポーネント
 */
const analysis_rd = {
    title: '現状分析'
}
const check_cluster = {
    title: '企業間分析で注目クラスタを確認',
    text01:
        '注目したクラスタ（技術群）に対して特定の企業と自社のスコア（技術競争力）を比較し、相対的な自社のポジションを確認します。\n自社の独自性や自社優位性のある要素技術を把握していきます。また、より有望なクラスタがある場合は確認するクラスタを変更しながら分析を深めることができます。',
    howToUse01:
        '企業間分析画面にて、自社と比較したい特定の企業（競合他社、提携候補先など）を選択します。（最大5社まで比較可能）',
    howToUse02:
        'スコア（技術競争力）の高さが濃淡で表示されるため、自社が優位性を持っているクラスタかどうかを確認できます。',
    howToUse03:
        '比較した結果、競合他社の方が優れており、独自性や自社優位性の発揮が困難であると判断した場合、注目するクラスタを見直したり、提携候補先の探索を検討することができます。'
}
const check_portfolio = {
    title: '企業間分析で技術ポートフォリオを確認',
    text01:
        '特定の企業と自社が保有している特許、技術情報についてより俯瞰的な視点で比較し、相対的な各社のポジショニング分析を行えます。'
}
const check_company = {
    title: '注目クラスタの特許や特許保有企業を確認',
    text01: '競合・川上・川下の保有特許内容から、自社が強みを発揮できそうな要素技術を明確化していきます。',
    howToUse01: '調べたい企業が決まっている場合',
    howToUse02:
        '「クラスタの特許出願一覧」から「特許出願保有企業」を絞って確認することで、競合他社等の特許一覧が取得できます。（表の右上のダウンロードアイコンを押下するとCSVファイルとしてダウンロードすることができます。データの絞り込みに便利です）',
    howToUse03:
        '特許の公開番号から他サービス等（Google Patent, Espacenet, J-PlatPatなど）で公開されている特許情報の詳細を確認し、周辺の対象顧客や課題の推察を行うことができます。',
    howToUse04: '調べたい企業が決まっていない場合',
    howToUse05:
        'クラスタに含まれている企業を探索した上で、対象顧客や課題の推察を行うことができます。\n注目したい企業を探すいくつかの方法として２点紹介します。',
    howToUse06: '技術競争力が高い企業：「クラスタ詳細（企業）」からスコアが一番高い企業を特定することができます。',
    howToUse07:
        'クラスタ内でより中心的な技術を持つ企業：「クラスタの特許出願一覧」の因子負荷量が一番高い順でソートした上で、「特許出願保有企業」を確認すると、特定できます。'
}

/**
 * Selection コンポーネント
 */
const selection = {
    title: '開発項目選定'
}
const cluster_map = {
    title: 'クラスタマップから更なる注目クラスタを確認',
    text01:
        'クラスタ＆バリューチェーンから技術動向を深掘りします。まずは、目的に応じた注目の技術群（クラスタ）を特定していきます。',
    howToUse01:
        'クラスタ・バリューチェーンは４つの領域に区切られており、目的に応じて確認するエリアが異なります。\n目的に応じて確認したい領域にある技術群を選択しましょう。',
    howToUse02:
        'R＆D戦略策定の場合は、各領域の技術を確認し、テーマ全体の技術動向とトレンドを把握することがおすすめです。',
    howToUse03:
        'その上で市場期待値の高さや自社技術の有無から各バリューチェーンにおいて注目すべき技術群（クラスタ）を抽出していきましょう。',
    howToUse04:
        'バブルを選択すると、画面下部のクラスタ一覧から、選択済みのクラスタに含まれる技術内容を確認できます。どのような技術があるのか領域ごとに探索することができます。',
    howToUse05:
        'クラスタ一覧から、注目したいクラスタを特定する場合は、例えば以下のような視点から確認すると示唆が得られます。',
    howToUse06: '＜スコア＞',
    howToUse07:
        '技術の進展度（スコア）が高いクラスタを特定したい場合は、「クラスタ一覧」の「スコア」をクリックし、データを降順にソートすると最も技術が進展しているクラスタがわかります。',
    howToUse08: '＜スコア成長率＞',
    howToUse09:
        '技術の成長率が高いクラスタを特定したい場合は、「クラスタ一覧」の「スコア成長率」をクリックし、データを降順にソートすると近年最も急速に技術が成長しているクラスタがわかります。',
    howToUse10: '＜市場期待値＞',
    howToUse11:
        '市場からの注目度が高いクラスタを特定したい場合は、「クラスタ一覧」の「市場期待値」をクリックし、データを降順にソートすると最も市場からの注目度が高いクラスタがわかります。',
    howToUse12: '＜市場期待値成長率＞',
    howToUse13:
        '市場からの注目度の成長率が高いクラスタを特定したい場合は、「クラスタ一覧」の「市場期待値成長率」をクリックし、データを降順にソートすると近年最も急速に市場からの注目度が上昇しているクラスタがわかります。',
    tips01: 'バブルが小さい（大きい）場合、「＋」ボタンで拡大（「-」ボタンで縮小）することができます。',
    tips02: '「設定」より表示データの変更や、x軸、y軸の設定、ズームスライダーの非表示など設定することができます。',
    tips03:
        'バブルチャートのx軸y軸の近くにあるスライダーを動かすことで表示する軸の領域を絞り込みができ、見たいエリアを拡大して確認することができます。',
    tips04: '「ラベル固定」を押すとクラスタ情報のラベルを固定表示できます。'
}
const company_info = {
    title: 'クラスタ内の企業情報を確認し、顧客課題を推定',
    text01: '川上企業情報からサプライヤーを、川下企業情報から顧客を探索し課題を推定します。',
    text02: 'スタートアップの財務・投資面からみた有望性を捉え、アライアンスやM&Aの可能性を検討していきます。',
    howToUse01: '顧客課題を推定したい場合',
    howToUse02:
        'バブルチャートからクラスタを選択した状態または、クラスタ一覧でクラスタを選択した状態で「クラスタ詳細（企業）」へ遷移します。',
    howToUse03: '該当の企業名をクリックし、企業情報の画面に遷移します。',
    howToUse04:
        '企業情報の画面では、大まかな「事業概要」を把握し、深掘りの必要がある場合は「一般情報」の「ウェブサイト」から該当企業のホームページに遷移できます。ホームページの内容を読み込み、顧客や課題をさらに推定していきます。',
    howToUse05:
        '企業情報の画面では、その企業が出願している特許の一覧をダウンロードできます。一覧の内容を確認することで顧客・課題の特定ができます。',
    tips01: 'Shiftボタンを押してから表の各項目名をクリックすると複数項目でソートができます。'
}
const consider = {
    title: 'スタートアップの財務・投資面から見た有望なアライアンスやM&Aの検討',
    text01: 'スタートアップの財務・投資面からみた有望性を捉え、アライアンスやM&Aの可能性を検討していきます。',
    howToUse01: 'スタートアップ企業リストを一括でリスト化したい場合',
    howToUse02:
        'バブルチャートからクラスタを選択した状態または、クラスタ一覧でクラスタを選択した状態で「クラスタ詳細（企業）」へ遷移します。',
    howToUse03: '右上のダウンロードアイコンをクリックし、CSVファイルをダウンロードします。',
    howToUse04:
        'CSVファイルをExcel等のソフトで開き、「スタートアップ=1（※）」で絞り込むとスタートアップの候補先のロングリストが作成できます。',
    howToUse05: '気になるスタートアップ企業をピックアップしてリスト化する場合',
    howToUse06:
        'バブルチャートからクラスタを選択した状態または、クラスタ一覧でクラスタを選択した状態で「クラスタ詳細（企業）」へ遷移します。',
    howToUse07:
        '気になるスタートアップ企業を探索します。\n例）スタートアップかつマイノリティ出資額が大きい（小さい）企業、スコア（技術競争力）が高い企業などを特定',
    howToUse08:
        '企業名をクリックし、企業情報を確認し、財務状況や投資元の企業の情報を踏まえて候補になる場合は、「お気に入りに登録」クリックし注目した企業を記録することができます。',
    howToUse09: '「クラスタ詳細（企業）」の右上のダウンロードアイコンをクリックし、CSVファイルをダウンロードします。',
    howToUse10:
        'CSVファイルをExcel等のソフトで開き、「スタートアップ=1（※）」、お気に入りに登録した企業名のみでフィルターをかけると、ロングリストが作成できます。',
    howToUse11: '※「1」がスタートアップ、「0」がスタートアップではないことを意味しています。',
    tips01:
        '画面上でスタートアップ企業を確認したい場合は、表の「スタートアップ」をクリックすると、単項目で昇順、降順のソートができます。降順に並び替えるとスタートアップ企業を一番最初に表示できます。',
    tips02: 'Shiftボタンを押してから表の各項目名をクリックすると複数項目でソートができます。'
}

/**
 * Decision コンポーネント
 */
const decision = {
    title: 'R&D戦略の策定'
}
const feature_company = {
    title: '特許出願の推移で注目企業を確認',
    text01: '特定企業の特許出願の推移から企業の技術開発動向を把握していきます。',
    howToUse01:
        'バブルチャートからクラスタを選択した状態または、クラスタ一覧でクラスタを選択した状態で「クラスタの特許出願推移」をクリックします。',
    howToUse02: '該当のクラスタのなかで特許出願数が多い上位10社の特許出願数の推移が確認できます。',
    howToUse03:
        '直近2年は（出願公開がまだのため）データが不足している可能性があります。直近2年を除いたデータの傾向を確認していきましょう。',
    howToUse04: '競合他社の技術開発の推移状況を踏まえて競合他社の技術開発動向を予測します。',
    howToUse05:
        '取り組むべき技術、重点的に開発すべき技術が明らかになるまで現状分析~R&D戦略策定を繰り返し、分析を深めていきます。'
}
const create_report_rd = {
    title: 'R&D戦略策定に向けた報告用のレポートの作成',
    text01:
        '注目クラスタ及び顧客と顧客が持つ課題、提供価値、ロングリスト等が用意でき、事業創出、事業化に向けて報告用のレポート作成が可能となります。Intelligent Business Analyticsでは、レポート作成時に便利な機能をご用意しています。',
    howToUse01: `競合他社との強み弱み分析（企業間分析）結果や、注目クラスタ及び顧客と顧客が持つ課題、提供価値、アライアンス候補先のロングリスト等の情報が用意でき、R&D戦略策定に向けて報告用のレポート作成が可能となります。
    1）選定テーマのテーマ概要【図表】（技術開発の傾向として報告）
    2）企業間比較（自社、競合、アライアンス候補）【図表】（自社優位性の裏付けとなる）
    3）競合他社、川上、川下企業の保有特許出願一覧【 CSVファイル】（注目クラスタの特許情報及び想定顧客と想定課題、提供価値の裏付けとなる）
    4）クラスタ&バリューチェーンのバブルチャート【図表】（注目クラスタIDを表示）
    5）アライアンス（M&A）候補先のロングリスト【CSVファイル】`
}

/**
 * EvaluationImprovement コンポーネント
 */
const evaluation_improvement = {
    title: '評価と改善'
}
const revision = {
    title: '動向を鑑みたR&D戦略の修正',
    text01: '四半期や半期毎に、最新の技術トレンドや競合他社の動向を踏まえて、R&D戦略を修正していきます。'
}

/**
 * テキスト側での指定は
 * `newBusiness.${アンカーリンク}.xxxx`
 */
export const newBusiness = {
    pdf: '新規事業策定のユースケース説明資料 [PDF 376KB]',
    sign_in,
    technological_development,
    select,
    grasp,
    value_provided,
    specific,
    specific_issues,
    analysis,
    assumed_tasks,
    analyze_technology,
    create_list,
    hypothesis,
    grasp_technology,
    create_report,
    tips
}

/**
 * テキスト側での指定は
 * `strategyDevelopment.${アンカーリンク}.xxxx`
 */
export const strategyDevelopment = {
    pdf: 'R&D戦略策定のユースケース説明資料 [PDF 433KB]',
    sign_in_rd: sign_in,
    technological_development_rd: technological_development,
    select_rd: select,
    grasp_rd: grasp,
    analysis_rd,
    check_cluster,
    check_portfolio,
    check_company,
    selection,
    cluster_map,
    company_info,
    consider,
    decision,
    feature_company,
    create_report_rd,
    evaluation_improvement,
    revision,
    tips
}

export const howToUse = {
    title: '使い方',
    description:
        'Intelligent Business Analyticsの主な利用ケースにおける操作方法と分析方法の観点についてポイントをご紹介しております。\nご自身の用途に必要な手順をご確認ください。\n説明で使用している画面・データは開発中の画面であり、実際の画面と異なる場合があることをご了承ください。',
    labelNewBusiness: '新規事業開発',
    labelStrategyDevelopment: 'R&D戦略策定',
    Usecase: '利用ケース',
    howToUse: 'ご利用方法'
}
